import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  PropType,
  CSSProperties,
  watch,
  ref,
} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
  title: String,
  content: String,
  model: Boolean,
  persistent: Boolean,
  titleStyle: {
    type: Object as PropType<CSSProperties>,
    required: false,
  },
},
  emits: ["update:model"],
  setup(__props, { emit: __emit }) {

const props = __props;

const localModel = ref(props.model);

const emit = __emit;

watch(
  () => props.model,
  (newValue) => {
    console.log("props.model changed", newValue);
    localModel.value = newValue;
  },
  { immediate: true },
);

watch(
  () => localModel.value,
  (newValue) => {
    if (newValue !== props.model) {
      emit("update:model", newValue);
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_VCol = _resolveComponent("VCol")!
  const _component_VDialog = _resolveComponent("VDialog")!

  return (_openBlock(), _createBlock(_component_VDialog, {
    modelValue: localModel.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModel).value = $event)),
    persistent: props.persistent,
    style: {"display":"flex","flex-direction":"column","width":"auto","font-family":"ui-sans-serif,\n        system-ui,\n        Open Sans,\n        Arial,\n        sans-serif"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VCol, { style: {"display":"flex","flex-direction":"column","width":"auto","margin":"auto","min-width":"400px","background-color":"white","border-radius":"12px","padding":"28px","gap":"16px"} }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header"),
          _createVNode(_component_VCol, { style: {"display":"flex","gap":"12px","padding":"0"} }, {
            default: _withCtx(() => [
              _createElementVNode("h3", {
                style: _normalizeStyle(props.titleStyle)
              }, _toDisplayString(props.title), 5),
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "persistent"]))
}
}

})